import BdcDocuments from "../components/Bdc/Documents";

const BdcDocumentsPage = () => <BdcDocuments />;

export default BdcDocumentsPage;
